export const GOOGLEPAY_INSTRUMENT_TYPE = 'wallet/googlepay';
export const STANDALONE_SUBMIT_INSTRUMENT_TYPE = 'wallet/googlepay-direct';
export const DIRECT_GATEWAY_ID = 'boxpay';

export const GOOGLE_PAY_SCRIPT_URL = 'https://pay.google.com/gp/p/js/pay.js';

export const getGooglePayWalletEntry = (sessionDetails) => (
  sessionDetails?.configs?.paymentMethods?.find((el) => el.instrumentTypeValue === GOOGLEPAY_INSTRUMENT_TYPE)
);

export const isDirectGooglePayGateway = (additionalData) => (
  additionalData?.gateway === DIRECT_GATEWAY_ID
);

export const getStandaloneGooglePayConfig = (sessionDetails) => {
  const googlePayEntry = getGooglePayWalletEntry(sessionDetails);
  const additionalData = googlePayEntry?.additionalData || {};

  return {
    environment: process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION' ? 'PRODUCTION' : 'TEST',
    merchantId: additionalData.merchantId,
    merchantName: additionalData.merchantName,
    gateway: additionalData.gateway,
    gatewayMerchantId: additionalData.merchantId,
    allowedPaymentMethods: additionalData.allowedPaymentMethods || [],
  };
};
